import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FinancialEntityNamesFailure, FinancialEntityNamesRequest, FinancialEntityNamesSuccess } from './actions';
import { FinancialEntityNamesService } from './service';

@Injectable()
export class FinancialEntityNamesEffects {
  private readonly actions$ = inject(Actions);
  private readonly financialEntityNamesService = inject(FinancialEntityNamesService);

  financialEntityNames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FinancialEntityNamesRequest),
      switchMap(({ parameters }) =>
        this.financialEntityNamesService.financialEntityNames(parameters).pipe(
          map(data => FinancialEntityNamesSuccess({ data })),
          catchError(error => of(FinancialEntityNamesFailure({ error })))
        )
      )
    )
  );

}
